// sendOTPSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sendOTP } from "../../api/OTPApi";
import Cookies from "js-cookie";

// import { sendOTP } from "../apiEndpoints";

export const sendOTPAsync = createAsyncThunk(
  "sendOTP/fetch",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await sendOTP(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const sendOTPSlice = createSlice({
  name: "sendOTP",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetSendOTPState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOTPAsync.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendOTPAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;

        // Extract customer ID and token
        const customerId = state?.data?.data?.user_data?.id;
        const tokenId = state?.data?.data?.user_data?.token?.id;
        const email = state?.data?.data?.user_data.email;
        const customer_category_id =
          state?.data?.data?.user_data?.customer_cat_id;

        // Set cookies for customer ID and token
        localStorage.setItem("customerId", customerId);
        Cookies.set("customerId", customerId, { expires: 7 });
        Cookies.set("token", tokenId, { expires: 7 });
        Cookies.set("email", email, { expires: 7 });
        Cookies.set("customer_category_id", customer_category_id, {
          expires: 7,
        });
      })
      .addCase(sendOTPAsync.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetSendOTPState } = sendOTPSlice.actions;
export default sendOTPSlice.reducer;
